import React, { useState } from 'react'
import { TouchableOpacity, View, ViewStyle } from 'react-native'
import { observer } from 'mobx-react-lite'

import { Text } from '../text'
import { CountdownTimer } from '../countdown-timer'
import { color } from '../../theme'
import { SvgIcon } from '../svg-icon'
import { iconLibraryPlay } from '../../assets'

export interface SubscriptionCardProps {
  title: string
  description: string | null
  statusLabel: string
  expiredLabel: string
  expired?: boolean
  accentColor?: string | null
  expirationDate?: string
  onPress: () => void
  style?: ViewStyle
}

export const SubscriptionCard = observer((props: SubscriptionCardProps) => {
  const { title, description, expiredLabel, expired, accentColor, expirationDate, style, onPress } =
    props

  const [timerExpired, setTimerExpired] = useState(false)

  const isExpired = expired || timerExpired

  const titleColor = isExpired ? color.shade50 : undefined
  const subtitleColor = isExpired ? color.shade30 : color.shade70
  const dotColor = isExpired ? color.shade30 : color.green
  const statusColor = isExpired ? color.shade50 : '#0A8F52'

  return (
    <TouchableOpacity
      onPress={onPress}
      style={[
        CARD,
        accentColor && !isExpired && { borderStartColor: accentColor, borderLeftWidth: 4 },
        isExpired && { opacity: 0.7 },
        style,
      ]}
    >
      <Text
        style={[titleColor ? { color: titleColor } : {}]}
        text={title}
        variant="titleEmphasized"
        numberOfLines={2}
      />
      {description && (
        <Text
          numberOfLines={3}
          text={description}
          variant="body2"
          style={{ color: subtitleColor, marginVertical: 12, marginBottom: 16 }}
        />
      )}
      {isExpired ? (
        <View style={{ flexDirection: 'row', gap: 8, alignItems: 'center' }}>
          <View style={{ height: 8, width: 8, borderRadius: 100, backgroundColor: dotColor }} />
          <Text text={expiredLabel} variant="body2" style={{ color: statusColor }} />
        </View>
      ) : expirationDate ? (
        <View style={FOOTER}>
          <CountdownTimer
            date={expirationDate}
            variant="subscription"
            onExpire={() => setTimerExpired(true)}
            style={{ alignSelf: 'flex-start' }}
          />
          <SvgIcon src={iconLibraryPlay} size={24} />
        </View>
      ) : (
        <View style={FOOTER}>
          <View style={{ flexDirection: 'row', gap: 8, alignItems: 'center' }}>
            <View style={{ height: 8, width: 8, borderRadius: 100, backgroundColor: dotColor }} />
            <Text text="Active" variant="body2" style={{ color: statusColor }} />
          </View>
          <SvgIcon src={iconLibraryPlay} size={24} />
        </View>
      )}
    </TouchableOpacity>
  )
})

const CARD: ViewStyle = {
  padding: 16,
  borderWidth: 1,
  borderColor: '#E6E6E6',
  backgroundColor: '#fff',
  width: '100%',
  minHeight: 136,
  borderRadius: 20,
  flex: 1,
  flexDirection: 'column',
  justifyContent: 'space-between',
}

const FOOTER: ViewStyle = {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
}
